<template>
  <div class="yh-page">
      <el-card>
        <el-row slot="header" type="flex" justify="start" align="middle" class="p-3" :gutter="10">
          <el-col :span="24">
            <el-input placeholder="输入保单号信息进行搜索..." v-model.trim="query.search"
                        @keyup.enter.native="handleSearch">
                <el-button slot="append" icon="el-icon-search" :loading="searching" @click="handleSearch">搜索</el-button>
            </el-input>
          </el-col>
          <el-col :span="4">
            <router-link :to="{name: 'createBillingRecord', query:{company: company, fileId: fileId}}" v-show="showAdd">
                <el-button type="primary" size="small" icon="el-icon-plus">新增</el-button>
            </router-link>
            &nbsp;
            <span>
                <el-button type="primary" size="small" icon="el-icon-back" @click="goBack">返回</el-button>
            </span>
          </el-col>
        </el-row>
        <el-row>
          <component ref="recordList" :is="recordListComponent"
            :loading="loading"
            :loadingText="loadingText"
            :list="list" >
          </component>
        </el-row>
      </el-card>
      <pagination ref="pagination" :size.sync="query.limit" :offset.sync="query.offset" :total="total" @updateList="getList"></pagination>
  </div>
</template>

<script>
import {fetchBillingRecords, fetchBillingRecordsByFileId} from '@/api/billing'
import {capitalizedWord} from '@/utils'
import Pagination from '@/components/Pagination'
import BillingRecordListPingAn from './billing-record/billing-record-list-ping-an'
import BillingRecordListZiJin from './billing-record/billing-record-list-zi-jin'
import BillingRecordListYongAn from './billing-record/billing-record-list-yong-an'
import BillingRecordListYongCheng from './billing-record/billing-record-list-yong-cheng'
import BillingRecordListYihe from './billing-record/billing-record-list-yihe'
import BillingRecordListRenBao from './billing-record/billing-record-list-ren-bao'
import BillingRecordListTaiBao from './billing-record/billing-record-list-tai-bao'
import BillingRecordListTaiBaoDongGuan from './billing-record/billing-record-list-tai-bao-dong-guan'
import BillingRecordListDaDi from './billing-record/billing-record-list-da-di'
import BillingRecordListDongHai from './billing-record/billing-record-list-dong-hai'
import BillingRecordListDongHaiGuangDong from './billing-record/billing-record-list-dong-hai-guang-dong'
import BillingRecordListGuoRen from './billing-record/billing-record-list-guo-ren'
import BillingRecordListHuaAn from './billing-record/billing-record-list-hua-an'
import BillingRecordListZhongYiCai from './billing-record/billing-record-list-zhong-yi-cai'
import BillingRecordListDaJia from './billing-record/billing-record-list-da-jia'
import BillingRecordListTianAnQingYuan from './billing-record/billing-record-list-tian-an-qing-yuan'

export default {
  name: "billing-record-list",
  components: {
    Pagination,
    BillingRecordListPingAn,
    BillingRecordListZiJin,
    BillingRecordListYongAn,
    BillingRecordListYongCheng,
    BillingRecordListYihe,
    BillingRecordListRenBao,
    BillingRecordListTaiBao,
    BillingRecordListTaiBaoDongGuan,
    BillingRecordListDaDi,
    BillingRecordListDongHai,
    BillingRecordListDongHaiGuangDong,
    BillingRecordListGuoRen,
    BillingRecordListHuaAn,
    BillingRecordListZhongYiCai,
    BillingRecordListDaJia,
    BillingRecordListTianAnQingYuan,
  },
  data() {
    return {
      showAdd: false,
      company: '',
      fileId: 0,
      invoice_type:0,
      recordListComponent: '',
      searching: false,
      loading: false,
      loadingText: '正在加载数据，请稍等...',
      query: {
        search: '',
        offset: 0,
        limit: 20
      },
      total: 0,
      list: []
    }
  },
  methods: {
    getList() {
      this.loading = true
      fetchBillingRecordsByFileId(this.query, this.company, this.fileId)
        .then(res => {
          this.list = res.results
          this.total = res.count
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$error_message(error)
        })
    },
    handleSearch() {
      // this.getList()
      this.$refs.pagination.backNumOne()
    },
    handleUpdate(id) {
      this.$router.push({name: 'updateBillingRecord', query: {company: this.company, fileId: this.fileId, id: id }})
    },
    goBack() {
      this.$router.go(-1)
    }
  },
  created() {
    // 入参处理
    if (this.$route.query.company === undefined || this.$route.query.fileId === undefined){
      this.$router.push('/404')
    }
    this.company = this.$route.query.company
    this.fileId= this.$route.query.fileId
    this.invoice_type = this.$route.query.invoice_type

    if (this.$route.query.search !== undefined){
      this.query.search = this.$route.query.search
    }

    // 权限检查
    if (!this.$perm(["billing.list_billing_record"])) {
      this.$router.push('/401')
    }

    if (this.invoice_type===1) {
      this.company = 'yihe'
    }

    if (this.$perm(["billing.create_billing_record"]) && this.company==='yihe') {
      // this.showAdd = true
    }

    const capitalizedCompanyName = capitalizedWord(this.company)
    let componentName = 'BillingRecordList' + capitalizedCompanyName
    console.log(componentName)
    this.recordListComponent = componentName
    console.log(this.recordListComponent)
    // this.recordListComponent = 'BillingRecordListPingAn'

    this.getList()
  }
}
</script>
